var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCardIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 27,
    viewBox: "0 0 30 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M11.5713 0.13187C15.2217 -0.0741173 18.8824 -0.038748 22.5278 0.237732C26.1904 0.751919 28.4287 3.26236 29.5713 7.0129H18.1765V17.3571H11.5713V0.13187Z",
    fill: "#C5C5C5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M21.2139 17.3571V10.2856H29.571V17.3571H21.2139Z",
    fill: "#C5C5C5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8.35714 17.3571H0V10.2856H8.35714V17.3571Z",
    fill: "#C5C5C5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M17.9999 20.5713V26.9999H11.5713V20.5713H17.9999Z",
    fill: "#C5C5C5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M0.642578 7.07143C0.997834 5.1816 1.9458 3.46511 3.34007 2.18702C4.73434 0.908939 6.49736 0.140366 8.35686 0V7.07143H0.642578Z",
    fill: "#C5C5C5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M21.2139 26.9999V20.5713H28.9282C28.4903 22.3902 27.4972 24.0058 26.1027 25.1679C24.7081 26.3301 22.9898 26.974 21.2139 26.9999Z",
    fill: "#C5C5C5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8.35686 20.5713V26.9741C5.23367 27.3076 1.61077 24.3563 0.642578 20.5713H8.35686Z",
    fill: "#C5C5C5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIcon);
export default __webpack_public_path__ + "static/media/card-icon.3d917a06e9ba5facb63d1308972d5ab6.svg";
export { ForwardRef as ReactComponent };